export default function (key) {
  return key !== 'delete';
}



// WEBPACK FOOTER //
// ./src/utils/auth.js